import { DELIVERY_CLASS, type ShippingMethod } from '@hooks-api/types/dataModel/shipping'
import { type ContainerProps } from '@pets-ui/Container/Container'
import { Container } from '@pets-ui/Container/Container'
import { VStack } from '@pets-ui/VStack/VStack'
import { FreeShippingTips } from '../FreeShippingTips/FreeShippingTips'

export interface FooterShippingsProps extends ContainerProps {
  /**
   * 總金額，計算免運門檻
   */
  totalAmount?: number
  shippingMethods?: ShippingMethod[]
  currency?: string
  positionMode?: 'normal' | 'absolute'
}

export const FooterShippings = (props: FooterShippingsProps) => {
  const { totalAmount = 0, shippingMethods, currency, positionMode, ...rest } = props
  /**
   * TODO: 常溫冷凍目前分開下單，先拿第一個 shipping rule 來判斷 delivery class
   */
  const normalShippingRules = shippingMethods?.flatMap(item => item.shipping_rules[DELIVERY_CLASS.NORMAL])
  const frozenShippingRules = shippingMethods?.flatMap(item => item.shipping_rules[DELIVERY_CLASS.FROZEN])
  const isAbsolute = positionMode === 'absolute'

  if (!normalShippingRules && !frozenShippingRules) return null

  // 將運費排序，取最小的運費
  const normalShippingRule = [...(normalShippingRules || [])].sort((a, b) => (a?.applied_shipping_fee.fee || 0) - (b?.applied_shipping_fee.fee || 0))[0]
  const frozenShippingRule = [...(frozenShippingRules || [])].sort((a, b) => (a?.applied_shipping_fee.fee || 0) - (b?.applied_shipping_fee.fee || 0))[0]

  if (!normalShippingRule || !frozenShippingRule) return null

  // 沒有 max_amount 代表沒有門檻，直接給 100%
  const normalPercentage = normalShippingRule.applied_shipping_fee.max_amount ? Math.round(totalAmount / normalShippingRule.applied_shipping_fee.max_amount * 100) : 100
  const frozenPercentage = frozenShippingRule.applied_shipping_fee.max_amount ? Math.round(totalAmount / frozenShippingRule.applied_shipping_fee.max_amount * 100) : 100
  const isFrozenFullBox = frozenShippingRule.applied_shipping_fee.max_amount === null

  return (
    <Container py={3} display="flex" justifyContent="flex-end" position="relative" {...rest}>
      <VStack gap={2} alignItems="flex-end" {...(isAbsolute && { position: 'absolute', right: 0, bottom: 12 })}>
        {normalShippingRules && (
          <FreeShippingTips
            currency={currency}
            isFree={normalShippingRule?.applied_shipping_fee.fee === 0}
            isNormalShipping
            leftAmount={normalShippingRule?.applied_shipping_fee.fee || 0}
            percentage={normalPercentage}
            // TODO: 待與 PM 確認顯示邏輯，新版已沒有 display
            // tooltipText={normalShippingMethod?.display}
          />
        )}
        {frozenShippingRules && (
          <FreeShippingTips
            currency={currency}
            isFree={frozenShippingRule?.applied_shipping_fee.fee === 0}
            isFrozenFullBox={isFrozenFullBox}
            isNormalShipping={false}
            leftAmount={frozenShippingRule?.applied_shipping_fee.fee || 0}
            percentage={frozenPercentage}
            // TODO: 待與 PM 確認顯示邏輯，新版已沒有 display
            // tooltipText={frozenShippingMethod?.display}
          />
        )}
      </VStack>
    </Container>
  )
}
